export const VIEW_STATE_ITINERARY = 0;
export const VIEW_STATE_LANDING_PAGE = 1;
export const VIEW_STATE_CATHAY_PACIFIC = 2;
export const VIEW_STATE_QRCODR = 3;
export const VIEW_STATE_LOGIN = 4;
export const VIEW_STATE_MY_TRIPS = 5;

export const POI_DETAIL_TYPE_FOR_ITINERARY = 6;
export const POI_DETAIL_TYPE_FOR_COLLECTIONS = 7;
export const POI_DETAIL_TYPE_FOR_RECOMMENDATIONS = 8;
export const POI_DETAIL_TYPE_FOR_SEARCH_POIS = 9;

export const VIEW_STATE_SETTINGS = 10;
export const VIEW_STATE_PROFILE = 11;
